const DATE_PARTS_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const getAgeFromBirthAt = (
  birthAt: string | null,
  currentDate = new Date()
): number | null => {
  const dateParts = birthAt?.match(DATE_PARTS_PATTERN);

  if (!dateParts) {
    return null;
  }

  const birthYear = Number(dateParts[1]);
  const birthMonth = Number(dateParts[2]);
  const birthDay = Number(dateParts[3]);
  const birthDate = new Date(birthYear, birthMonth - 1, birthDay);

  const isValidDate =
    birthDate.getFullYear() === birthYear &&
    birthDate.getMonth() === birthMonth - 1 &&
    birthDate.getDate() === birthDay;

  if (!isValidDate || birthDate > currentDate) {
    return null;
  }

  const hasBirthdayPassed =
    currentDate.getMonth() > birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() &&
      currentDate.getDate() >= birthDate.getDate());

  return (
    currentDate.getFullYear() -
    birthDate.getFullYear() -
    (hasBirthdayPassed ? 0 : 1)
  );
};
